import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS,
  AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME,
} from '@modules/affiliate-program-creatives/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  AFFILIATE_PROGRAM_CREATIVES_BULK_ADD_ROUTE_NAME,
  AFFILIATE_PROGRAM_CREATIVES_CREATE_ROUTE_NAME,
  AFFILIATE_PROGRAM_CREATIVES_EDIT_ROUTE_NAME,
} from './constants';

export class AffiliateProgramCreativesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_CREATIVES_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramEditCreativePage/AffiliateProgramEditCreativePage.vue'),
    });

    router.addChildRoute(AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_CREATIVES_CREATE_ROUTE_NAME,
      path: 'create',
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramEditCreativePage/AffiliateProgramEditCreativePage.vue'),
    });

    router.addChildRoute(AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_CREATIVES_BULK_ADD_ROUTE_NAME,
      path: 'create-bulk',
      permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramEditCreativePage/AffiliateProgramEditCreativePage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
